export default __webpack_public_path__ + "static/media/loading.6373c88d.gif";